import useCheckMobileScreen from "./useCheckMobileScreen"

export const useIsDesignV2 = (): boolean => {
  const isMobile = useCheckMobileScreen()

  // Future-ready logic (kept commented intentionally)
  // const user = getUser()
  // const guestUser = isGuestUser(user)
  // const isEmailAuthorized = isUserAuthorizedForDesignV2()

  // Final decision logic
  // return isMobile && !guestUser && isEmailAuthorized

  return isMobile
}
